import React from "react";
import { motion } from "framer-motion";
import "./WhyInvest.css";
import { useLanguage } from "../../contexts/LanguageContext";

const WhyInvest = () => {
  const { translations: tRaw } = useLanguage();
  const t = {
    investment: {},
    ...tRaw,
    investment: { ...tRaw?.investment },
  };

  const points = [
    t.investment?.why?.[0] || "Access a fast-growing digital economy.",
    t.investment?.why?.[1] || "Earn passive income from a real-world application.",
    t.investment?.why?.[2] || "Get early investor privileges in upcoming funding rounds.",
    t.investment?.why?.[3] || "Contribute to a future-focused tech solution.",
  ];

  return (
    <section className="why-invest-section">
      {/* Floating background elements */}
      <div className="why-invest-background">
        {[...Array(6)].map((_, i) => (
          <motion.div
            key={i}
            className="why-invest-floating-circle"
            initial={{ 
              x: Math.random() * 100 - 50,
              y: Math.random() * 100 - 50,
              opacity: 0
            }}
            animate={{
              x: [null, Math.random() * 100 - 50],
              y: [null, Math.random() * 100 - 50],
              opacity: [0, 0.15, 0],
            }}
            transition={{
              duration: Math.random() * 15 + 15,
              repeat: Infinity,
              repeatType: "reverse",
              ease: "linear"
            }}
          />
        ))}
      </div>

      <motion.div
        className="why-invest-container"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5 }}
      >
        <motion.h2
          className="why-invest-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          {t.investment?.whyTitle || "Why Invest in iWinto?"}
        </motion.h2>
        
        <div className="why-invest-points">
          {points.map((point, index) => (
            <motion.div
              key={index}
              className="why-point"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -5 }}
              transition={{ 
                duration: 0.5, 
                delay: index * 0.15,
                ease: [0.16, 1, 0.3, 1]
              }}
            >
              <div className="why-point-content">
                <div className="why-bullet-container">
                  <span className="why-bullet">✓</span>
                </div>
                <p>{point}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default WhyInvest;